var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_755_1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.04297 15.9941C8.04297 17.055 8.4644 18.0724 9.21454 18.8226C9.96469 19.5727 10.9821 19.9941 12.043 19.9941C13.1038 19.9941 14.1213 19.5727 14.8714 18.8226C15.6215 18.0724 16.043 17.055 16.043 15.9941C16.043 14.9333 15.6215 13.9159 14.8714 13.1657C14.1213 12.4156 13.1038 11.9941 12.043 11.9941C10.9821 11.9941 9.96469 12.4156 9.21454 13.1657C8.4644 13.9159 8.04297 14.9333 8.04297 15.9941Z",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0076 20.5527C19.8413 26.3619 14.3152 31.4229 12.0427 31.4229C9.18554 31.4229 1.18555 23.4229 1.18555 15.9943C1.18555 9.99812 6.04646 5.13721 12.0427 5.13721C12.3814 5.13721 12.7165 5.15273 13.0473 5.18308",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5896 9.19009C16.8269 9.05741 16.8269 7.96246 17.5896 7.82977C20.3529 7.34904 22.5506 5.24435 23.1505 2.50449L23.1964 2.29447C23.3615 1.54064 24.4348 1.53595 24.6063 2.28831L24.6623 2.53306C25.2842 5.25999 27.4826 7.34691 30.238 7.8263C31.0047 7.95967 31.0047 9.06019 30.238 9.19357C27.4826 9.67295 25.2842 11.7599 24.6623 14.4868L24.6063 14.7316C24.4348 15.4839 23.3615 15.4792 23.1964 14.7254L23.1505 14.5154C22.5506 11.7755 20.3529 9.67082 17.5896 9.19009Z",
    stroke: "#1020AE",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_755_1579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.574707)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.88fb0127f43ddbaeb4701c83bb9e00d8.svg";
export { ForwardRef as ReactComponent };